(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  // Default Shop/collection sort: Best selling
  if (!url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.pathname + url.search + url.hash);
  }

  if (url.hash) {
    const targetId = url.hash.slice(1);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    const scrollToHashTarget = () => {
      const target = document.getElementById(targetId);
      if (!target) return;

      requestAnimationFrame(() => {
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'instant' : 'smooth',
          block: 'start',
        });
      });
    };

    if (document.readyState === 'complete') {
      scrollToHashTarget();
    } else {
      window.addEventListener('load', scrollToHashTarget, { once: true });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
